<template>
  <div>
    <el-dialog :title="$t('text.modify')"
               :visible="isShowModifyDialog"
               width="600px"
               @close="handleDialog"
               :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item :label="$t('text.changeOrderStatusTo')" prop="toStatus">
        <el-radio-group v-model="form.toStatus" >
          <el-radio label="01">{{$t('orderStatus.01') }}</el-radio>
          <el-radio label="02">{{$t('orderStatus.02')}}</el-radio>
        </el-radio-group>
      </el-form-item>

        <el-form-item :label="$t('text.channelOrderId')"
                      prop="channelOrderId">
          <el-input size="small"
                    type="text"
                    v-model="form.channelOrderId"
                    :placeholder="$t('message.inputChannelOrderId')"
                    maxlength="64"/>
        </el-form-item>
        <el-form-item :label="$t('text.orderAmount')" v-if="this.orderAmount != null">
          <el-input size="small"
                    type="text"
                    v-model="orderAmount"
                    disabled/>
        </el-form-item>
        <el-form-item prop="refId" :label="$t('text.refId')" v-if="this.$store.state.isBD && isPayin">
          <el-input size="small"
                    type="text"
                    v-model="form.refId"
                    :placeholder="$t('message.inputRefId')"/>
        </el-form-item>

        <el-form-item :label="$t('text.realPay')" prop="actualAmount" v-if="this.orderAmount != null || (this.$store.state.isBD && isPayin)">
          <el-input size="small"
                    type="text"
                    v-model="form.actualAmount"
                    :placeholder="$t('message.inputRealPay')"/>
        </el-form-item>
        <el-form-item :label="$t('text.remark')"
                      prop="msg">
          <el-input size="small"
                    type="textarea"
                    v-model="form.msg"
                    :placeholder="$t('message.inputRemark')"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowModifyDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    orderAmount: {
      type: String,
      default: null
    },
    refId: {
      type: String,
      default: ""
    },
    isPayin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const generateRules = () => {
      const rules = {
        toStatus: [{required: true, message: this.$t('message.orderStatusRequiredError'), trigger: "change"}],
        channelOrderId: [{validator: validateChannel, trigger: "change"}],
        actualAmount: [{validator: this.validateAmount, trigger: "change"}],
      };
      if (this.$store.state.isBD) {
        rules.refId = [{validator: validateRefId, trigger: "change"}];
      }

      return rules;
    };

    let validateChannel = (rule, value, callback) => {
      const regex = /^[A-Za-z0-9]+$/;

      if (regex.test(value) || !value) {
        callback();
      }

      return callback(new Error(this.$t('message.invalidChannelOrderId')));
    };

    let validateRefId = (rule, value, callback) => {
      if (this.form.toStatus === '01') {
        if (!value) {
          callback(new Error(this.$t('message.inputRefId')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return {
      form: {
        toStatus: "",
        channelOrderId: "",
        actualAmount: null,
        refId: this.refId,
        msg: ""
      },
      rules: generateRules()
    };
  },
  watch: {
    isShowModifyDialog(val) {
      if (val) {
        this.form.refId = this.refId;
      }
    }
  },
  methods: {
    handleDialog() {
      this.$refs["form"].resetFields();
      this.form = {
        toStatus: "",
        channelOrderId: "",
        refId: "",
        msg: ""
      };
      this.$emit("update:isShowModifyDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.refId && this.form.toStatus) {
            if (this.refId !== this.form.refId) {
              this.$confirm(this.$t('message.confirmModifyRefId'), this.$t('text.prompt'), {
                confirmButtonText: this.$t('text.confirm'),
                cancelButtonText: this.$t('text.cancel'),
                type: 'warning'
              }).then(() => {
                this.submitForm();
              }).catch(() => {
              })
            } else {
              this.submitForm();
            }
          } else {
            this.submitForm();
          }
        }
      });
    },
    submitForm() {
      const params = {
        ...this.form,
        orderId: this.id
      };
      this.$axios.post("/order/updateOrderStatus", params).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.operationSuccessful'),
            message: this.$t('text.updateSuccessMessage'),
            type: "success"
          });
          this.$emit("update:isShowModifyDialog", false);
          this.$bus.$emit("refresh"); //通知刷新
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
      });
    },
    validateAmount(rule, value, callback) {
      if (value == null){
        callback();
      }
      const submitAmount = parseFloat(value);
      if (isNaN(submitAmount) || submitAmount <= 0) {
        callback(new Error(this.$t('message.numericError')));
      } else {
        callback();
      }
    }
  }
};
</script>
